import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m34.669 5.11 8.032 7.893a7.358 7.358 0 0 1 2.2 5.184L45 29.447a7.358 7.358 0 0 1-2.11 5.222l-7.893 8.032a7.358 7.358 0 0 1-5.184 2.2L18.553 45a7.358 7.358 0 0 1-5.222-2.11l-8.032-7.893a7.358 7.358 0 0 1-2.2-5.184L3 18.553a7.358 7.358 0 0 1 2.11-5.222l7.893-8.032a7.358 7.358 0 0 1 5.184-2.2L29.447 3a7.358 7.358 0 0 1 5.222 2.11Zm-1.473 1.5a5.256 5.256 0 0 0-3.73-1.508l-11.26.099a5.256 5.256 0 0 0-3.704 1.571L6.61 14.805a5.256 5.256 0 0 0-1.507 3.73l.099 11.26a5.256 5.256 0 0 0 1.571 3.703l8.033 7.893a5.255 5.255 0 0 0 3.73 1.507l11.26-.099a5.256 5.256 0 0 0 3.703-1.571l7.893-8.032a5.255 5.255 0 0 0 1.507-3.73l-.099-11.26a5.256 5.256 0 0 0-1.571-3.704L33.196 6.61ZM15.899 17.384 22.514 24l-6.615 6.615c-.991.99.495 2.477 1.486 1.486L24 25.487l6.615 6.614c.99.991 2.477-.495 1.486-1.486L25.487 24l6.614-6.615c.991-.99-.495-2.477-1.486-1.486L24 22.514l-6.615-6.615c-.99-.991-2.477.495-1.486 1.486Z",
      clipRule: "evenodd"
    }
  )
);
var SvgStopOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var StopOutlined_default = SvgStopOutlined;

export { StopOutlined_default as default };
